import React, { FC, useState } from 'react';

import { AtsType, IntegrationType } from 'src/generated/mloop-graphql';

import { WorkdayIntegration, useIntegrationDelete } from 'src/hooks/api/integration';
import { getAtsService } from 'src/hooks/atsService';

import { DisconectAtsDialog } from '../Dialogs/DisconnectAtsDialog';
import WorkdayDialog from '../Dialogs/WorkdayDialog';
import IntegrationCard from '../IntegrationCard';

import { ConnectAtsButton } from './ConnectAtsButton';

export interface Props {
  workday?: WorkdayIntegration;
  disabled?: boolean;
  onConnect?: () => void;
  onRemove?: () => void;
}

const WorkdayCard: FC<Props> = ({ workday, disabled = false, onConnect, onRemove }) => {
  const [isDialogOpen, setDialogOpen] = useState<boolean>(false);
  const [openRemoveDialog, setOpenRemoveDialog] = useState<boolean>(false);

  const deleteWorkday = useIntegrationDelete(IntegrationType.Workday);

  const atsService = getAtsService(AtsType.Workday);

  return (
    <>
      <IntegrationCard
        dataTestId="workday-card-integration-card"
        logo={atsService.logoUrl}
        name="Workday"
        onConnect={workday ? undefined : () => setDialogOpen(true)}
        onManageSetup={workday ? () => setDialogOpen(true) : undefined}
        onRemove={workday ? () => setOpenRemoveDialog(true) : undefined}
        disabled={disabled}
        disableManageSetup={disabled}
        connectButton={
          <ConnectAtsButton
            dataTestId="workday-card-integration-card"
            handleConnect={() => setDialogOpen(true)}
            disabled={disabled}
          />
        }
      />

      {isDialogOpen && (
        <WorkdayDialog
          disabled={disabled}
          workdayIntegration={workday}
          onClose={() => setDialogOpen(false)}
          onSave={() => {
            setDialogOpen(false);
            onConnect?.();
          }}
        />
      )}

      {openRemoveDialog && (
        <DisconectAtsDialog
          integrationName={atsService.name}
          onClose={() => {
            setOpenRemoveDialog(false);
          }}
          onRemove={() => {
            setOpenRemoveDialog(false);
            deleteWorkday.mutate(undefined, {
              onSuccess: () => {
                onRemove?.();
              },
            });
          }}
        />
      )}
    </>
  );
};

export default WorkdayCard;
